<script>
import { mapState, mapMutations, mapGetters } from "vuex";
import { filter, get, orderBy, groupBy } from "lodash";
import Tile from '@/components/tile.vue';
import {planTypes} from "@/common/constants";
import base from '@/views/config/addon-cards/templates/base.vue';
import logo from '@/assets/plans/zoom_scheduler.svg';
import { DEFAULT_SCHEDULER_PLAN_CAPACITY, additionalZoomSchedulerAsAddonCardCheck } from '@/plans/ZOOM_MEETING/common/utils';
import { pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';

export default {
  name: 'ZoomSchedulerAddOnCard',
  mixins: [base],
  components: {
    Tile,
  },
  for: (arg) => {
    const GET_SELECTED_PLANS_INDEX = 2; // src/views/config/core.vue - function call - filterAddonForKeys
    return additionalZoomSchedulerAsAddonCardCheck(arg[GET_SELECTED_PLANS_INDEX]) ? planTypes.map([ planTypes.ZOOM_MEETING, planTypes.ZOOM_ONE_BUNDLE ]): []
  },
  created() {
    const { amount } = this.lowestPlan;
    this.subtitle = this.$t('billing.common.form_xx_month', [this.$money(amount)]);
  }, 
  data() {
    return {
      logo,
      title: this.$t('billing.scheduler.title'),
      subtitle: '',
      planType: planTypes.ZOOM_SCHEDULER,
      description: this.$t('billing.scheduler.desc'),
      form: DEFAULT_SCHEDULER_PLAN_CAPACITY,
      isNewAddOn: false,
    }
  },
  computed: {
    ...mapGetters(['getSelectedPlans']),
    ...mapState({
      planMapFlat: state => state.ShoppingCart.planMapFlat,
    }),
    lowestPlan() {
      const list = orderBy(filter(this.planMapFlat, (p) => p.type === planTypes.ZOOM_SCHEDULER && !p.isOneMonth), ['participants', 'amount'], 'asc')
      return get(list, [0], {});
    },
    basePlanBillingCycle () {
      const basePlanTypes = getPlanTypeByCategory(pageConfig.plan || 'pro')
      return this.getSelectedPlans.find((item) => item.type === basePlanTypes)?.billing_cycle || this.form.billingCycle;
    },
    zonePlans() {
      return this.planMapFlat.filter((item) => item.type === planTypes.ZOOM_SCHEDULER);
    },
    zonePlanGroupByCategory() {
      return groupBy(this.zonePlans, 'category');
    },
    // current selected meeting plan
    formPlan() {
      return this.zonePlanGroupByCategory[this.form.category].find(
        (item) => item.billing_cycle === this.basePlanBillingCycle,
      );
    },
  },
  methods: {
    ...mapMutations(['updateSelectPlan']),
    addOn(evt) {
      // addPlanFromEnterKey For A11Y requirement
      // target is BUTTON comes from keyboard enter, will auto focaus on the first option in config card
      // target is SPAN comes from click
      const addPlanFromEnterKey = get(evt.target, 'tagName', '') == 'BUTTON';
      if (addPlanFromEnterKey) {
        document.addPlanFromEnterKey = true;
      }
      this.updateSelectPlan({
        ...this.formPlan,
        cartInfo: {
          selected_number: this.form.selectedNumber,
        },
      });
      this.$emit('add', this.$options?.key);
      this.$tracking.addOnBuyInteraction('add-ons', `${this.title?.toLowerCase()} - add`);
      this.$nextTick(this.focusToConfig);
    },
  }
};
</script>